import React, { useEffect, useRef } from "react";
import styled from "styled-components";

/* ─── Document icon (Figma 650:4164) ─── */
const DocIconSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 2C4 1.44772 4.44772 1 5 1H12L16 5V18C16 18.5523 15.5523 19 15 19H5C4.44772 19 4 18.5523 4 18V2Z"
      stroke="#475569"
      strokeWidth="1.4"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M12 1V5H16" stroke="#475569" strokeWidth="1.4" strokeLinejoin="round" fill="none" />
  </svg>
);

/* ─── AI Sparkle icon (user-provided) ─── */
const AISparkleIcon = () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.75 1.82812C10.7597 1.82812 11.5781 1.00964 11.5781 0H12.4219C12.4219 1.00964 13.2403 1.82812 14.25 1.82812V2.67188C13.2403 2.67188 12.4219 3.49036 12.4219 4.5H11.5781C11.5781 3.49036 10.7597 2.67188 9.75 2.67188V1.82812ZM0 6.75C2.48528 6.75 4.5 4.73528 4.5 2.25H6C6 4.73528 8.01472 6.75 10.5 6.75V8.25C8.01472 8.25 6 10.2647 6 12.75H4.5C4.5 10.2647 2.48528 8.25 0 8.25V6.75ZM2.90701 7.5C3.89038 8.0457 4.70432 8.8596 5.25 9.843C5.79568 8.8596 6.60962 8.0457 7.593 7.5C6.60962 6.9543 5.79568 6.1404 5.25 5.15701C4.70432 6.1404 3.89038 6.9543 2.90701 7.5ZM12.1875 9C12.1875 10.3462 11.0962 11.4375 9.75 11.4375V12.5625C11.0962 12.5625 12.1875 13.6538 12.1875 15H13.3125C13.3125 13.6538 14.4038 12.5625 15.75 12.5625V11.4375C14.4038 11.4375 13.3125 10.3462 13.3125 9H12.1875Z" fill="#475569" />
    <path d="M9.75 1.82812C10.7597 1.82812 11.5781 1.00964 11.5781 0H12.4219C12.4219 1.00964 13.2403 1.82812 14.25 1.82812V2.67188C13.2403 2.67188 12.4219 3.49036 12.4219 4.5H11.5781C11.5781 3.49036 10.7597 2.67188 9.75 2.67188V1.82812ZM0 6.75C2.48528 6.75 4.5 4.73528 4.5 2.25H6C6 4.73528 8.01472 6.75 10.5 6.75V8.25C8.01472 8.25 6 10.2647 6 12.75H4.5C4.5 10.2647 2.48528 8.25 0 8.25V6.75ZM2.90701 7.5C3.89038 8.0457 4.70432 8.8596 5.25 9.843C5.79568 8.8596 6.60962 8.0457 7.593 7.5C6.60962 6.9543 5.79568 6.1404 5.25 5.15701C4.70432 6.1404 3.89038 6.9543 2.90701 7.5ZM12.1875 9C12.1875 10.3462 11.0962 11.4375 9.75 11.4375V12.5625C11.0962 12.5625 12.1875 13.6538 12.1875 15H13.3125C13.3125 13.6538 14.4038 12.5625 15.75 12.5625V11.4375C14.4038 11.4375 13.3125 10.3462 13.3125 9H12.1875Z" fill="url(#paint0_linear_650_4346)" />
    <defs>
      <linearGradient id="paint0_linear_650_4346" x1="-3.78" y1="24.375" x2="23.7632" y2="18.9035" gradientUnits="userSpaceOnUse">
        <stop offset="0.0109882" stopColor="#FFD22E" />
        <stop offset="0.605034" stopColor="#AC6CFF" />
        <stop offset="0.743945" stopColor="#6A72E6" />
      </linearGradient>
    </defs>
  </svg>
);

/* ─── Enter-key icon (Figma 650:4161) ─── */
const EnterIconSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 3V8.5H4.5M4.5 8.5L7 6M4.5 8.5L7 11"
      stroke="#0f172a"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ─── Styled components ─── */

/* Divider line between input and dropdown body */
const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
`;

/* "Press Enter to ask AI ✨" row — Figma 650:4151 */
const AIHintBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 12px;
  background: #f7f7f7;
  border-radius: 8px;
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 6px;
    padding: 8px 10px;
  }
`;

const AIHintContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 140px;
  min-width: 0;

  & > svg {
    flex-shrink: 0;
  }
`;

const AIHintText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

/* Enter badge — Figma 650:4159 */
const EnterBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 4px;
  flex-shrink: 0;
  margin-left: auto;

  @media (max-width: 480px) {
    padding: 3px 4px;
  }
`;

const EnterBadgeText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

/* Suggestion row — Figma 650:4163 */
const SuggestionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f6f5f4;
  }
`;

const SuggestionText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #525252;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* "View all results" row — Figma 650:4175 */
const ViewAllRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 3px;
  border-radius: 4px;
  cursor: pointer;
`;

const ViewAllText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #525252;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  text-decoration-skip-ink: none;
`;

/* No results state */
const NoResultsMessage = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #64748b;
  text-align: center;
  padding: 16px 16px 12px;
`;

/* ─── Helper: extract plain text from HTML title ─── */
function extractPlainTitle(htmlTitle) {
  if (!htmlTitle) return "";
  const span = document.createElement("span");
  span.innerHTML = htmlTitle;
  return (span.textContent || span.innerText || "").trim();
}

/* ─── Main component ───
   Renders an absolutely positioned dropdown below the search input.
   Figma node 650:4148. */

export default function SearchSuggestionsDropdown({
  inputRef,
  items,
  onSelect,
  onViewAll,
  isAIEnabled,
  onClose,
}) {
  const cardRef = useRef(null);

  /* Close on click outside */
  useEffect(() => {
    const handleMouseDown = (e) => {
      if (
        cardRef.current &&
        !cardRef.current.contains(e.target) &&
        inputRef?.current &&
        !inputRef.current.contains(e.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, [onClose, inputRef]);

  /* Close on Escape */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const hasNoResults = !items || items.length === 0;
  const suggestions = hasNoResults ? [] : items.slice(0, 3);

  return (
    <div
      ref={cardRef}
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        zIndex: 9998,
        borderRadius: "0 0 16px 16px",
        background: "#ffffff",
        boxShadow:
          "0px 0px 2px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Divider between input area and suggestions */}
      <DividerLine />

      {/* Dropdown body — Figma 650:4148: padding top 8px, bottom 12px, left/right 16px, gap 6px */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          padding: "8px 16px 12px",
          pointerEvents: "auto",
        }}
      >
        {hasNoResults ? (
          <>
            <NoResultsMessage>
              {isAIEnabled
                ? "We're sorry. No results were found, Try asking AI"
                : "We're sorry. No results were found."}
            </NoResultsMessage>
            {isAIEnabled && (
              <AIHintBar>
                <AIHintContent>
                  <AIHintText>Press Enter to search with AI</AIHintText>
                  <AISparkleIcon />
                </AIHintContent>
                <EnterBadge>
                  <EnterBadgeText>Enter</EnterBadgeText>
                  <EnterIconSvg />
                </EnterBadge>
              </AIHintBar>
            )}
          </>
        ) : (
          <>
            {/* AI Hint bar — Figma 650:4151 */}
            {isAIEnabled && (
              <AIHintBar>
                <AIHintContent>
                  <AIHintText>Press Enter to search with AI</AIHintText>
                  <AISparkleIcon />
                </AIHintContent>
                <EnterBadge>
                  <EnterBadgeText>Enter</EnterBadgeText>
                  <EnterIconSvg />
                </EnterBadge>
              </AIHintBar>
            )}

            {/* Suggestion rows — Figma 650:4163 */}
            {suggestions.map((item, i) => (
              <SuggestionRow
                key={item.articleId || i}
                onClick={() => onSelect(item, i)}
              >
                <DocIconSvg />
                <SuggestionText>{extractPlainTitle(item.title)}</SuggestionText>
              </SuggestionRow>
            ))}

            {/* View all results — Figma 650:4175 */}
            <ViewAllRow onClick={onViewAll}>
              <ViewAllText>View all results</ViewAllText>
            </ViewAllRow>
          </>
        )}
      </div>
    </div>
  );
}
